export default __webpack_public_path__ + "static/media/integration.44208f49.svg";